import { render, staticRenderFns } from "./ModalNotificationUser.vue?vue&type=template&id=290c6418&scoped=true&"
import script from "./ModalNotificationUser.vue?vue&type=script&lang=ts&"
export * from "./ModalNotificationUser.vue?vue&type=script&lang=ts&"
import style0 from "./ModalNotificationUser.vue?vue&type=style&index=0&id=290c6418&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "290c6418",
  null
  
)

export default component.exports